import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Barchart = () => {
  const data = {
    labels: [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ],
    datasets: [
      {
        data: [240, 280, 2000, 260, 1500, 250, 1000, 800, 1300, 950, 1750, 1200],
        backgroundColor: '#007df3',
        barThickness: 20,
        categoryPercentage: 0.8, // 👈 يقلل المسافة بين الأعمدة
        barPercentage: 0.9,      // 👈 يجعل الأعمدة أعرض نسبياً داخل المساحة
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {},
    },
  };

  return <Bar data={data} options={options} />;
};

export default Barchart;
